import { render, staticRenderFns } from "./ModalSuscripcionStart.vue?vue&type=template&id=971e2626&scoped=true&"
import script from "./ModalSuscripcionStart.vue?vue&type=script&lang=js&"
export * from "./ModalSuscripcionStart.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuscripcionStart.vue?vue&type=style&index=0&id=971e2626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971e2626",
  null
  
)

export default component.exports